export interface ApiError {
	statusCode?: number;
	details?: string;
}

export const getParsedApiError = (error: any | undefined): ApiError => {
	if (!error || !error.response) {
		return {};
	}

	const statusCode = error.response.status;
	const data = error.response.data;

	const details: string = data?.Details;

	return {
		statusCode,
		details,
	};
};
